import React, { FC, PropsWithChildren, useMemo, useState } from 'react'
import { ThemeContext, themeByCSSVariables } from '@shared/lib/theme'

const ThemeProvider: FC<PropsWithChildren> = ({ children }) => {
  const [theme, setTheme] = useState(themeByCSSVariables)

  const value = useMemo(() => ({ theme, setTheme }), [theme, setTheme])

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
}

export default ThemeProvider
